import { NotificationsOff } from '@mui/icons-material'
import { Typography } from '@mui/material'
import React from 'react'
import { VBox } from '../../elements/basic-elements'
import { FormBox } from '../../elements/form-elements'
import StandardButton from '../buttons/standard-button'
import CenteredModal from '../modals/centered-modal'

const PushBlockedModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => (
  <CenteredModal open={open} onClose={onClose} showClose>
    <FormBox padding={{ xs: '8px 0px 16px', sm: '8px 8px 16px' }}>
      <VBox alignItems="center" gap={2.5}>
        <NotificationsOff sx={{ fontSize: 56, opacity: 0.4, mt: 1 }} />
        <VBox gap={1} textAlign="center">
          <Typography variant="h5" color="textPrimary" fontWeight={600}>
            Notifications blocked
          </Typography>
          <Typography variant="body2" color="textSecondary">
            It looks like you blocked notifications in your browser. To receive push notifications
            from What Can I Do, you'll need to re-enable them manually.
          </Typography>
        </VBox>
        <VBox gap={0.5} textAlign="center">
          <Typography variant="body2" color="textSecondary" fontWeight={500}>
            How to re-enable:
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Click the <strong>lock icon</strong> (or <strong>info icon</strong>) in your browser's
            address bar, find <strong>Notifications</strong>, and set it to{' '}
            <strong>Allow</strong>.
          </Typography>
        </VBox>
        <StandardButton variant="contained" onClick={onClose} sx={{ mt: 1 }}>
          Got it
        </StandardButton>
      </VBox>
    </FormBox>
  </CenteredModal>
)

export default PushBlockedModal
